import React from 'react'
import style from './TypesBlock.module.css'
import { shingle, tpo, metal } from '../../../Assets/Images/Roofing/TypesBlock/Index'

const TypesBlock = () => {
  const types = [
    {
      title: 'Shingle',
      image: shingle,
      description: 'A versatile and cost-effective choice, shingles provide a classic look with reliable weather protection. They are engineered to endure harsh conditions while enhancing your property\'s overall curb appeal.',
      tags: ['Weather Resistant', 'Cost-Effective', 'Versatile Styles'],
    },
    {
      title: 'TPO/EPDM',
      image: tpo,
      description: 'Ideal for flat roofs, these high-performance membranes offer superior waterproofing and energy efficiency. They reflect UV rays to lower cooling costs and remain flexible under extreme temperature changes.',
      tags: ['UV Reflective', 'Superior Waterproofing', 'Energy Efficient'],
    },
    {
      title: 'Metal',
      image: metal,
      description: 'Providing modern design and extreme longevity, metal roofing is a high-strength, fire-resistant solution. It is built to withstand severe weather conditions with minimal maintenance required over its long lifespan.',
      tags: ['Extreme Longevity', 'Fire Resistant', 'Low Maintenance'],
    },
  ]

  return (
    <section className={style.types}>
      <div className="customContainer">
        <div className={style.header}>
          <div className={style.line}></div>
          <h2 className={style.title}>Types Of Roofing</h2>
          <div className={style.line}></div>

        </div>
        <div className={style.grid}>
          {types.map((type, index) => (
            <div key={index} className={style.card}>
              <div className={style.image_wrap}>
                <img src={type.image} alt={type.title} className={style.image} />
              </div>
              <div className={style.content}>
                <div className={style.card_header}>
                  <p className={style.textDecorate}>Type</p>
                  <h3 className={style.card_title}>{type.title}</h3>
                </div>
                <div className={style.line} />
                <p className={style.description}>{type.description}</p>
                <div className={style.tags}>
                  {type.tags.map((tag, i) => (
                    <span key={i} className={style.tag}>{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TypesBlock
